import React from 'react';
import { Grid, Typography } from 'housecall-ui';
import HousecallProLogo from 'housecall-ui/dist/IconsAndImages/Logos/HousecallProLogo';

export const Footer = () => {
  return (
    <Grid container justify="center" spacing={1}>
      <Grid item>
        <Typography variant="caption" color="textPrimary">
          Powered by
        </Typography>
      </Grid>
      <Grid item>
        <HousecallProLogo color="primary" width={90} height={13} />
      </Grid>
    </Grid>
  );
};
